import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export const Layout = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
  justify-content: center;
  align-items: center;
  background-color: ${COLOR.ALABASTER};
`;

export const PageTitle = styled.div`
  margin: 1em;
  font-size: 3em;
  color: ${COLOR.OUTER_SPACE};
`;
